import React from 'react'

import NavigationMenuSection from "../../menu-items/section/section"
import NavigationMenuItemProjectWithChildren from "../../menu-items/project/menu-item-project-with-children"
import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import {SpaceProto} from "../../../../core/model2/space/space-proto"
import ProjectSession from "../../../../core/model2/project/project-session"
import MainMenu_SectionReorderableWithMore from "../menu-controller/menu-section-reordable-with-more"
import ErrorBoundary from "../../../../core/error-boundary"
import NavigationMenu_ItemProjectWithReorder from "../../menu-items/project/menu-item-project-with-reorder"

type Props = {
    systemName? : string        // is used for menu collapsed/expanded settings identification
    space       : SpaceProto
}

// const debug = "NavigationMenu_StarredProjects"
const debug = false

export default function NavigationMenu_StarredProjects(props:Props) {

    const starredProjects    = props.space.starredProjects

    if (_.isEmpty(starredProjects)) {
        return null
    }

    const onReorderEnd = (items: any) => {
        debug && console.log(debug, 'onReorderEnd', items)

        if (!gd.user.settings.menu.projectsStarred[props.space.id]) {
            gd.user.settings.menu.projectsStarred[props.space.id] = {}
        }

        gd.user.settings.menu.projectsStarred[props.space.id].sortPositions = _.map(items, (item: any) => {
            return item.id
        })
        gd.user.settings.menu.save()
    }

    // const colorize = props.space.projectsColorize

    const localSettings = new NavigationMenu_ProjectsLocalSettings()

    const components = _(starredProjects)
        .orderBy((project: ProjectSession) => {
            return _.indexOf(gd.user.settings.menu.projectsStarred?.[props.space.id]?.sortPositions, project.id)
        })
        .map((project: ProjectSession)=> {
            return {
                item        : project,
                component   :
                    <NavigationMenu_ItemProjectWithReorder
                        level                       = {0}
                        project                     = {project}
                        space                       = {props.space}
                        localSettings               = {localSettings}
                        expandedProjectsSettingName = "expandedProjects"
                    />
            }
        })
        .compact()
        .value()

    return (
        <NavigationMenuSection
            name        = "Starred"
            starred     = {true}
            systemName  = {props.systemName}
            collapsible = {true}
            counter     = {starredProjects.length}
        >
            {/*{starredProjects.map((project:ProjectSession)=>{

                return <NavigationMenuItemProjectWithChildren key={project.id} projectId={project.id} colorized={colorize} localSettings={localSettings} />

            })}*/}

            <ErrorBoundary>
                <MainMenu_SectionReorderableWithMore
                    countVisibleItems   = {5}
                    settingsKey         = "space-starred-items"
                    moreTitle           = "All Items"
                    showAdd             = {false}
                    components          = {components}
                    onReorderEnd        = {onReorderEnd}
                />
            </ErrorBoundary>
        </NavigationMenuSection>
    )
}
